var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCirclesCommonIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6469 6.68411C13.3474 6.68411 12.2939 5.62372 12.2939 4.31569C12.2939 3.00765 13.3474 1.94727 14.6469 1.94727C15.9464 1.94727 16.9998 3.00765 16.9998 4.31569C16.9998 5.62372 15.9464 6.68411 14.6469 6.68411Z",
    stroke: "#868FAD",
    strokeWidth: 1.5,
    strokeMiterlimit: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.88235 4.78947C1.84276 4.78947 1 3.94115 1 2.89474C1 1.8483 1.84276 1 2.88235 1C3.92193 1 4.76471 1.8483 4.76471 2.89474C4.76471 3.94115 3.92193 4.78947 2.88235 4.78947Z",
    stroke: "#868FAD",
    strokeWidth: 1.5,
    strokeMiterlimit: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4707 17.579L12.2942 15.2106V12.3685C12.2942 10.7266 13.2354 9.52637 14.6472 9.52637C16.0589 9.52637 17.0001 10.7266 17.0001 12.3685V14.6598V19.0001",
    stroke: "#868FAD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52941 14.7371L5.70588 12.3687V10.4739C5.70588 8.8321 4.76471 7.63184 3.35294 7.63184C1.94118 7.63184 1 8.8321 1 10.4739V11.8179V19.0003",
    stroke: "#868FAD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclesCommonIcon);
export default __webpack_public_path__ + "static/media/circlesCommonIcon.e245d90c5e2552b729fd373bce1e89f2.svg";
export { ForwardRef as ReactComponent };